import React, { Component } from 'react';
import '../css/project-image-zoom-modal.css'

class ProjectImageZoomModal extends Component {


    componentDidUpdate(prevProps) {
        if (this.props.isActive && !prevProps.isActive) {
            document.body.style.overflow = 'hidden';
        } else if (!this.props.isActive && prevProps.isActive) {
            document.body.style.overflow = '';
        }
    }

    componentWillUnmount() {
        document.body.style.overflow = '';
    }

    render() {
        if (this.props.isActive) {
            return (
                <div className='imageContainer' onClick={this.props.onClose}>
                    <div className='imageWrapper'>
                        <img className='zoomedImage' src={this.props.imageUrl} alt='zoomedImage' />
                    </div>
                </div>
            )
        }
    }
}

export default ProjectImageZoomModal;